import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptainGeneralInfoComponent } from './captain-general-info/captain-general-info.component';
import { CaptainRapidoAccountComponent } from './captain-rapido-account/captain-rapido-account.component';
import { CaptainEarningsComponent } from './captain-earnings/captain-earnings.component';
import { CaptainDateWiseStatDetailsComponent } from './captain-date-wise-stat-details/captain-date-wise-stat-details.component';
import { CaptainCurrentStatDetailsComponent } from './captain-current-stat-details/captain-current-stat-details.component';
import { CaptainOrderDetailsComponent } from './captain-order-details/captain-order-details.component';
import { SharedModule } from '../shared/shared.module';
import { CaptainDetailsComponent } from './captain-details.component';
import { MyHttpClient } from '../http-client.service';
import { CaptainService } from '../captain.service';
import { EntityService } from '../entity.service';
import { CaptainSubscriptionsService } from '../captain-subscriptions.service';
import { CaptainRedeemService } from '../captain-redeem-service';
import { CaptainSearchComponent } from './captain-search/captain-search.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContentLoaderModule } from '@netbasal/ngx-content-loader';
import { TableScrollableComponent } from '../table-scrollable/table-scrollable.component';
import { CaptainIncentiveProgressComponent } from './captain-incentive-progress/captain-incentive-progress.component';
import { MatTabsModule, MatIconModule, MatExpansionModule, MatFormFieldModule, MatDialogModule } from '@angular/material';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DailyIncentivesComponent } from './captain-incentive-progress/daily-incentives/daily-incentives.component';
import { WeeklyIncentivesComponent } from './captain-incentive-progress/weekly-incentives/weekly-incentives.component';
import { LinearProgressComponent } from './captain-incentive-progress/linear-progress/linear-progress.component';
import { CaptainActivitiesComponent } from './captain-activities/captain-activities.component';
import { CaptainBulkActionComponent } from './captain-bulk-action/captain-bulk-action.component';
import { CaptainRapidoPayLogsComponent } from './captain-rapidoPay-logs/captain-rapidoPay-logs.component';
import { SvoService } from '../svo.service';
import { EventService } from '../event.service';
import { CaptainTicketsComponent } from './captain-tickets/captain-tickets.component';
import { TicketConversationDialogComponent } from '../shared/ticket-conversation-dialog.component';
import { CaptainSubscriptionsComponent } from './captain-subscriptions/captain-subscriptions.component';
import { CaptainAvailableSubscriptionComponent } from './captain-availablesubscription.component/captain-availablesubscription.component';
import { RevokeFailedOrderComponent } from './captain-failed-orders/revoke-failed-order/revoke-failed-order.component';
import { SingleViewOfCaptainComponent } from './single-view-of-captain/single-view-of-captain.component';
import { CaptainPerformanceDataComponent } from './captain-performance-data/captain-performance-data.component';
import { HandHoldingDetailsComponent } from './hand-holding-details/hand-holding-details.component';
import { CaptainComplaintsByCustomerComponent } from './captain-complaints-by-customer/captain-complaints-by-customer.component';
import { CaptainRateCardComponent } from './captain-rate-card/captain-rate-card.component';
import { TicketsAgainstCaptainComponent } from './tickets-against-captain/tickets-against-captain.component';
import { CaptainCallLogsComponent } from './captain-call-logs/captain-call-logs.component';
import { CaptainCallLogsService } from '../captain-call-logs.service';
import { CaptainPropagationBreachesComponent } from './captain-propagation-breaches/captain-propagation-breaches.component';
import { CaptainPropagationEventsComponent } from './captain-propagation-events/captain-propagation-events.component';
import { CaptainLastLocationsComponent } from './captain-last-locations/captain-last-locations.component';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatInputModule } from '@angular/material/input'
import { MatNativeDateModule } from '@angular/material/core'
import { NativeDateAdapter } from '@angular/material/core';
import { CaptainAccessFeeDetails } from './captain-accessFee-details/captain-accessFee-details.component';
import { CaptainMakeModelPermissionsPopupComponent } from './captain-make-model-permissions/captain-make-model-permissions.component'
import { CaptainGemsTransactionDetails } from './captain-gem-transaction-details/captain-gem-transaction-details.component';
import { CaptainDuesTransactions } from './captain-dues-transactions/captain-dues-transactions.component';
import { LimitStoreService } from '../limit-store-service';
import { FinGatewayService } from '../fin-gateway.service';
import { CaptainMgEarningsComponent } from './captain-mg-earnings/captain-mg-earnings.component';

const routes: Routes = [{
  path: ':id',
  component: CaptainDetailsComponent,
}];
@NgModule({
  declarations: [
    CaptainGeneralInfoComponent,
    CaptainRapidoAccountComponent,
    CaptainEarningsComponent,
    CaptainDateWiseStatDetailsComponent,
    CaptainCurrentStatDetailsComponent,
    CaptainOrderDetailsComponent,
    CaptainDetailsComponent,
    CaptainSearchComponent,
    CaptainIncentiveProgressComponent,
    DailyIncentivesComponent,
    WeeklyIncentivesComponent,
    LinearProgressComponent,
    CaptainActivitiesComponent,
    CaptainBulkActionComponent,
    CaptainTicketsComponent,
    TicketConversationDialogComponent,
    TicketsAgainstCaptainComponent,
    CaptainRapidoPayLogsComponent,
    SingleViewOfCaptainComponent,
    RevokeFailedOrderComponent,
    CaptainPerformanceDataComponent,
    HandHoldingDetailsComponent,
    CaptainComplaintsByCustomerComponent,
    CaptainSubscriptionsComponent,
    CaptainAvailableSubscriptionComponent,
    CaptainRateCardComponent,
    CaptainCallLogsComponent,
    CaptainPropagationBreachesComponent,
    CaptainPropagationEventsComponent,
    CaptainLastLocationsComponent,
    CaptainAccessFeeDetails,
    CaptainMakeModelPermissionsPopupComponent,
    CaptainGemsTransactionDetails,
    CaptainDuesTransactions,
    CaptainMgEarningsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ContentLoaderModule,
    MatTabsModule,
    MatIconModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDialogModule,
    FontAwesomeModule,
    RouterModule.forRoot([]),
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule
  ],
  exports: [
    CaptainGeneralInfoComponent,
    CaptainRapidoAccountComponent,
    CaptainEarningsComponent,
    CaptainDateWiseStatDetailsComponent,
    CaptainCurrentStatDetailsComponent,
    CaptainOrderDetailsComponent,
    CaptainDetailsComponent,
    CaptainSearchComponent
  ],
  providers: [
    MyHttpClient,
    CaptainService,
    SvoService,
    EntityService,
    EventService,
    CaptainSubscriptionsService,
    CaptainCallLogsService,
    NativeDateAdapter,
    CaptainRedeemService,
    LimitStoreService,
    FinGatewayService
  ],
  entryComponents: [
    TicketConversationDialogComponent
  ]
})
export class CaptainDetailsModule { }
